// @ts-nocheck
 
 
 
 
 
/* eslint-disable import/order */
 
 
 
 
 
 
 
import React from 'react';
import { Route, Switch, useRouteMatch } from 'react-router-dom';
import { NotAuthorized } from 'app/components/not-authorized';
import { CardContainer } from 'app/components/shared/card-container';
import DocumentTypesTable from './DocumentTypesTable';
import { trimTrailingSlash, useTypedSelector } from 'helpers';
import { hasWriteAccessToFaresSubSystem, getIsSuperAdmin } from 'selectors';
import AddDocumentType from './addDocumentType';
import EditDocumentType from './updateDocumentType';
import ViewDocumentType from './view-DocumentType';

const DocumentTypes: React.FC = () => {
  const match = useRouteMatch();
  const baseURL = trimTrailingSlash(match.url);

  const hasDocumentTypesAddAccess = useTypedSelector(state =>
    hasWriteAccessToFaresSubSystem(state, 'DocumentTypes') // Assuming same subSystem spelling
  );

  // Document Types is GLOBAL (not multi-tenant) -> super-admin only (extra gate,
  // on top of the existing Fares-subsystem permission checks).
  const isSuperAdmin = useTypedSelector(getIsSuperAdmin);
  if (!isSuperAdmin) {
    return (
      <CardContainer>
        <NotAuthorized />
      </CardContainer>
    );
  }

  return (
    <CardContainer>
      <Switch>
        <Route path={`${baseURL}/new`}>
          {hasDocumentTypesAddAccess ? <AddDocumentType/> : <NotAuthorized />}
        </Route>

        <Route path={`${baseURL}/:id/edit`}>
          {hasDocumentTypesAddAccess ? <EditDocumentType/> : <NotAuthorized />}
        </Route>
        
        <Route path={`${baseURL}/:id`}>
          <ViewDocumentType/>
        </Route>
        
        <Route exact path={`${baseURL}`}>
          <DocumentTypesTable/>
        </Route>
      </Switch>
    </CardContainer>
  );
};

export { DocumentTypes };
